import { Component, signal } from '@angular/core';
import { CapitalContainer } from '@commons/capital-container/capital-container';
import { CapitalCard } from '@commons/capital-card/capital-card';
import { PrimaryButton } from '@commons/primary-button/primary-button';
import { CapitalInput } from '@commons/capital-input/capital-input';
import { Router } from '@angular/router';
import { CapitalBack } from "@commons/capital-back/capital-back";
import { AuthService } from '@commons/services/auth.service';
import { formatRutWithoutDots, isValidRutFormat } from '@utils/rut.utils';

@Component({
  selector: 'app-security-key-login',
  imports: [CapitalContainer, CapitalCard, PrimaryButton, CapitalInput, CapitalBack],
  templateUrl: './security-key-login.html',
  styleUrl: './security-key-login.scss',
})
export class SecurityKeyLogin {
  // Estado del formulario
  isLoading = signal<boolean>(false);
  errorMessage = signal<string | null>(null);

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService
  ) { }

  async onLogin(rut: string, password: string) {
    // Limpiar error anterior
    this.errorMessage.set(null);
    this.isLoading.set(true);

    try {
      // Normalizar el RUT al formato sin puntos (XXXXXXXX-X)
      const normalizedRut = formatRutWithoutDots(rut);
      
      // Realizar login
      await this.authService.login(normalizedRut, password);
      
      // Login exitoso, redirigir a home
      this.router.navigate(['/home-options']);
    } catch (error: any) {
      // Mostrar error
      this.errorMessage.set(error.message || 'Error al iniciar sesión. Por favor, verifica tus credenciales.');
      console.error('Error en login:', error);
    } finally {
      this.isLoading.set(false);
    }
  }

  validateRut = (value: string) => isValidRutFormat(value, 'dots');

  validatePassword = (value: string) => value.length >= 6;

}
